/**
 * Warning: breaks for UTF-8 strings with non-ascii characters.
 *
 * Naively reverses strings.
 */
export function naiveReverse(arg: string): string {
  return arg.split('').reverse().join('');
}
